// src/plugins/logger.ts
import { ClientPlugin, RequestConfig, LoggingPluginConfig } from "../types";

const DEFAULT_CACHE_CONFIG: Required<LoggingPluginConfig> = {
  enabled: true,
  logLevel: "info",
  logRequests: true,
  logResponses: true,
  logErrors: true,
  maskHeaders: [],
};

export class LoggerPlugin implements ClientPlugin {
  name = "logger";
  private config: Required<LoggingPluginConfig>;

  constructor(config: LoggingPluginConfig = {}) {
    this.config = { ...DEFAULT_CACHE_CONFIG, ...config };
  }

  beforeRequest(config: RequestConfig) {
    console.log(`[GraphQL Request] ${config.operation.key}`, {
      variables: config.variables,
    });
    return config;
  }

  afterRequest(response: any, config: RequestConfig) {
    console.log(`[GraphQL Response] ${config.operation.key}`, {
      data: response,
    });
    return response;
  }

  onError(error: Error, config: RequestConfig) {
    console.error(`[GraphQL Error] ${config.operation.key}`, {
      error,
      request: config,
    });
  }
}
